import { RateOptionTicketType } from 'obt-common/types/api/v1/obt/air/air_search_response';
import { useGetPolicyLabelText } from 'src/app/flights/shared/hooks/useGetPolicyLabelText';
import { OutOfPolicyLabel } from 'src/app/shared/components/OutOfPolicyLabel';

interface IProps {
  handlePolicyLabelClick: () => void;
  isOutOfPolicy: boolean;
  ticketType: RateOptionTicketType;
}

const FlightOutOfPolicyLabel = ({ handlePolicyLabelClick, isOutOfPolicy, ticketType }: IProps) => {
  const policyLabelText = useGetPolicyLabelText(ticketType, isOutOfPolicy);

  return (
    <OutOfPolicyLabel
      data-testid="out-of-policy-modal-label"
      onClick={handlePolicyLabelClick}
      label={policyLabelText}
      variant="error"
    />
  );
};

export { FlightOutOfPolicyLabel };
